var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id == null)?_c('div'):(_vm.loading)?_c('div',[_vm._v(" Loading ")]):(_vm.hasErrors)?_c('div',[_c('global-error-inline',{attrs:{"errors":_vm.errors}}),_c('v-btn',{attrs:{"small":"","depressed":"","color":"primary"},on:{"click":_vm.loadLocation}},[_vm._v("Retry")])],1):_c('div',[_vm._v(" "+_vm._s(_vm.location.trailName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }